import { formatMoney, MONEY_TOKENS } from '@repo/design-system-kit';
import { buildValidations, validator } from 'ember-cp-validations';

const MAX_SINGLE_PAYMENT_VALUE = 2100000000;

const OrganizationValidations = buildValidations({
  annualTurnover: [
    validator('presence', {
      presence: true,
      messageKey: 'partner-register-kyb.business-finances.annual-turnover.error-message',
    }),
  ],
  yearlyTransactionVolume: [
    validator('presence', {
      presence: true,
      messageKey: 'partner-register-kyb.business-finances.yearly-transaction-volume.error-message',
    }),
  ],
  maxSinglePaymentAmount: [
    validator('presence', {
      presence: true,
      messageKey: 'partner-register-kyb.business-finances.max-single-payment-amount.error-message',
    }),
    validator('number', {
      allowString: true,
      lte: MAX_SINGLE_PAYMENT_VALUE,
      messageKey:
        'partner-register-kyb.business-finances.max-single-payment-amount.error-message-amount',
      amount: formatMoney({
        amount: MAX_SINGLE_PAYMENT_VALUE,
        token: MONEY_TOKENS.SYMBOL_COMPACT,
      }),
    }),
  ],
});

export default OrganizationValidations;
